
<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div>
      <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
                <a-col :md="6" :sm="24">
                  <a-form-item :label="$t('品牌名称')" prop="brandName">
                    <a-input v-model="queryParam.brandName" @pressEnter="handleQuery" :maxLength="16" :placeholder="$t('请输入')+$t('品牌名称')" allow-clear/>
                  </a-form-item>
                </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('报表.订单开始时间')" prop="startTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.startTime"
                                 :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('报表.订单结束时间')" prop="endTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.endTime"
                                 :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="!advanced && 6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </div>
      <!-- 操作 -->
        <div class="table-operations">
          <a-button type="primary" @click="handleExport" v-hasPermi="['goods:goods:export']">
            <a-icon type="download" />{{$t('导出')}}
          </a-button>
          <a-button type="primary" :disabled="multiple"  @click="handleSelectExport" v-hasPermi="['goods:goods:export']">
            <a-icon type="download" />{{$t('选中导出')}}
          </a-button>
          <table-setting
            :style="{float: 'right'}"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList" />
        </div>
        <!-- 数据展示 -->
        <a-table
          class="sta-table"
          :loading="loading"
          size="small"
          rowKey="brandId"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          @change="handleSortChange"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :bordered="tableBordered"
        >

          <template slot="picture" slot-scope="text, record">
            <div>
              <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
            </div>
          </template>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :pageSizeOptions="pageSizeOptions"
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => getTotal(total)"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {brandSta, cateSta} from '@/api/statistics/goods'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import {tableMixin} from '@/store/table-mixin'
import moment from 'moment';

export default {
  name: 'Goods',
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      categoryList: [{id: "0", categoryName: ''}],
      cateOptions: [],
      brandList: [],
      labelList: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        brandName: undefined,
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('品牌名称'),
          dataIndex: 'brandName',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: this.$t('报表.商品销量'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'salesNum',
        },
        {
          title: this.$t('报表.商品销售额'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'goodsAmount',
        },
        {
          title: this.$t('报表.销售金额'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'payAmount',
        },
        {
          title: this.$t('报表.销售占比'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'payAmountRate',
        },
        {
          title: this.$t('报表.退款金额'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'refundAmount',
        },
        {
          title: this.$t('报表.退款单数'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'refundOrderCount',
        },
        {
          title: this.$t('报表.退款占比'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'refundAmountRate',
        },
        {
          title: this.$t('报表.退款量'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'refundNum',
        },
      ]
    };
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted() {
    this.resetQuery();
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商品列表 */
    getList () {
      this.loading = true
      brandSta(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },



    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        brandName: undefined,
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.brandId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },


    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('statistics/goods/cate/export',
            that.queryParam
          , `商品品牌报表_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出选中数据'),
        onOk () {
          that.download('statistics/goods/cate/export', queryParam, `商品品牌报表_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        }
      })
    }
  }
}
</script>
<style>
.sta-table .ant-table-thead > tr > th {
  background-color: #bae7ff !important;
}

</style>
